var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@mui/material/styles/styled';
import Avatar from '../Avatar';
import Box from '../Box';
import Typography from '../Typography';
import Chip from '../Chip';
import { EduExperience, WorkExperience } from './Experience';
var FbmUserInfoRoot = styled(Box)({
    display: 'flex',
});
var InfoRoot = styled(Box)({
    marginLeft: 5,
    position: 'relative',
    top: '-5px',
});
var NameRoot = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: '4px',
});
var PositionCountContainer = styled(Box)({
    width: '20px',
    height: '18px',
    background: '#E3F2FD',
    borderRadius: '4px',
    fontSize: 12,
    color: '#03A9F4',
    textAlign: 'center',
    lineHeight: '18px',
});
var NameText = styled(Typography)({
    height: 22,
});
export var DescTetx = styled(Typography)({
    height: 22,
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.56)',
});
var Chips = function (_a) {
    var chips = _a.chips;
    if (!chips || (chips && chips.length === 0))
        return null;
    var Items = chips.map(function (chip, index) { return (React.createElement(Chip, __assign({ key: index, color: 'primary', sx: { mr: '8px' } }, chip))); });
    return (React.createElement(Box, { sx: { mt: '8px' } }, Items));
};
var UserInfo = function (_a) {
    var avatar = _a.avatar, sex = _a.sex, name = _a.name, desc = _a.desc, chips = _a.chips, age = _a.age, positionCount = _a.positionCount, otherInfo = _a.otherInfo, eduExperience = _a.eduExperience, workExperience = _a.workExperience;
    return (React.createElement(FbmUserInfoRoot, null,
        React.createElement(Box, null,
            React.createElement(Avatar, { src: avatar, sex: sex })),
        React.createElement(InfoRoot, null,
            React.createElement(NameRoot, null,
                name && React.createElement(NameText, { mr: 2 }, name),
                age && React.createElement(DescTetx, { mr: 2 },
                    age,
                    "\u5C81"),
                positionCount && React.createElement(PositionCountContainer, null, positionCount),
                otherInfo),
            React.createElement(DescTetx, null, desc),
            React.createElement(Chips, { chips: chips }),
            React.createElement(EduExperience, { data: eduExperience }),
            React.createElement(WorkExperience, { data: workExperience }))));
};
UserInfo.defaultProps = {
    name: '',
    chips: []
};
export default UserInfo;
